export default {
	URL: 'https://api-lojapresentes.infinitum-ti.com',
	API_URL: 'https://api-lojapresentes.infinitum-ti.com/api',
	OAPI_URL: 'https://api-lojapresentes.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2411',
	// API_URL: 'http://localhost:2411/api',
	// OAPI_URL: 'http://localhost:2411/oapi',
}
